import {html, LitElement} from 'lit';
import {customElement, property} from 'lit/decorators.js';
import Features from '../../ts/services/features';

import type {ShareEventPayload} from './types';
import socialShareStyles from './social-share.styles';
import svgIconsStyles from './svg-icons.styles';

@customElement('ui-social-share')
export class SocialShare extends LitElement {
  static readonly styles = [svgIconsStyles, socialShareStyles];

  @property() type: 'facebook' | 'twitter' | 'mail' | 'whatsapp' | 'share';
  @property({attribute: 'twitter-account'}) account = '';
  @property({attribute: 'twitter-via'}) via = '';

  titleMapper: Record<string, string> = {
    'facebook': 'Auf Facebook teilen',
    'twitter': 'Auf X (ehemals Twitter) teilen',
    'mail': 'Per E-Mail versenden',
    'whatsapp': 'Auf WhatsApp teilen',
    'share': 'Teilen'
  };

  render() {
    if (this.type === 'share' && !Features.isShareSupported()) {
      this.classList.add('hidden');
      return null;
    }

    return html`
      <div class="wrapper">
        <button type="button" tabindex="-1" class="sb sb-${this.type}" @click=${this.clickHandler}>
          <span class="icon-svg-${this.type}" title="${this.title}"></span>
        </button>
      </div>
    `;
  }

  clickHandler() {
    const payload: ShareEventPayload = {type: this.type};

    if (this.type === 'twitter') {
      payload.account = this.account;
      payload.via = this.via;
    }

    this.dispatchEvent(new CustomEvent<ShareEventPayload>('customEventSocialClick', {detail: payload}));
  }

  get title() {
    return this.titleMapper[this.type];
  }
}
